// extracted by mini-css-extract-plugin
export default {"container":"rO-z","topReviewHeading":"sO-z","criticalReview":"tO-z","favorableReview":"uO-z","vsSeparator":"vO-z"};